import React, { useState, useEffect } from "react";
import { Container, Modal } from "react-bootstrap";
import RichText from "components/rich-text";
import * as style from "./style.mod.scss";
import CloseIcon from "assets/svgs/x-icon.svg";
import { useMediaQuery } from "react-responsive";
import { lazyLoadVideos } from "helpers/lazyLoadVideos";
import locale from "../../locales";

const VideosModal = ({ data }) => {
  const { title, mainVideo, modalVideo } = data;
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 1023.98px)" });

  const toggleModal = (isOpen) => setOpen(isOpen);

  useEffect(() => {
    lazyLoadVideos();
  }, []);



  useEffect(() => {
    if (isMobile && open) {
      const videoElement = document.getElementById("fullScreenVideo");
      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) {
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) {
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) {
        videoElement.msRequestFullscreen();
      }
    }
  }, [isMobile, open]);

  return (
    <>
      <Container>
        <div>
          <div className={style.title}>
            <RichText blocks={title} />
          </div>
          <div className={style.mainVideoContainer}>
            <video className={style.video} type="video/mp4" autoPlay muted playsInline loop controls>
              <source data-src={mainVideo.url} type="video/mp4" />
              Sorry, your browser doesnt support embedded videos.
            </video>
            {modalVideo &&
              <div onClick={() => toggleModal(true)} className={style.viewButton}>
                {locale.pages.panLanding.viewVideo}
              </div>}
          </div>
        </div>
      </Container >
      {modalVideo &&
        <Modal show={open && !isMobile} onHide={() => toggleModal(false)} className={style.modal}>
          <Modal.Body>
            <div className={style.modalContainer}>
              <div className={style.videoContainer}>
                <video className={style.videoModal} type="video/mp4" autoPlay muted playsInline loop>
                  <source src={modalVideo?.url} type="video/mp4" />
                  Sorry, your browser doesnt support embedded videos.
                </video>
                <div className={style.modalClose}>
                  <CloseIcon onClick={() => toggleModal(false)} />
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>}
      {
        isMobile && open && (
          <video id="fullScreenVideo" className={style.videoModal} type="video/mp4" autoPlay muted playsInline loop>
            <source data-src={mainVideo.url} type="video/mp4" />
            Sorry, your browser doesnt support embedded videos.
          </video>
        )
      }
    </>
  );
};

export default VideosModal;
